import { createContext, useState } from 'react'

export const TabContext = createContext<{value: string | null; onClick: (val: string) => void}>({
    value : '',
    onClick: (val: string) => {}
})

export const TabProvider = ({ children }) => {

  const [value, setValue] = useState<string|null>(null)

  const onClick = (val) => {
    // console.log('clickeando...')
    setValue(val)
  }

  return (
    <TabContext.Provider value={{ value, onClick }}>
        {children}
    </TabContext.Provider>
  )
}
